import React from 'react';
import { EntityForm } from '../../widgets/Forms';
import { CustomTextField } from '../../widgets/CustomTextField';

export default function EmployerSearchForm(props) {
        return (
            <EntityForm ref={React.createRef()} viewId="employer" values={props.data}
                entityLookupController={props.entityLookupController} org="saseta"
                entityLookupId={props.id} useCustomSettings={false} valueChangeHandler={props.valueChangeHandler}>
                {form =>
                    <form className={form.classes.container} id="EmployerSearchForm">
                        <div className="row search-form-container">
                            <div className="col form-col">
                                <CustomTextField
                                    id="OrganisationLegalName"
                                    label="Legal Name"
                                    className="w-100"
                                    onKeyPress={props.onKeyUp}
                                    InputProps={{
                                        readOnly: false,
                                    }}
                                    form={form}
                                />
                            </div>
                            <div className="col form-col">
                                <CustomTextField
                                    id="OrganisationTradeName"
                                    label="Trade Name"
                                    className="w-100"
                                    onKeyPress={props.onKeyUp}
                                    InputProps={{
                                        readOnly: false,
                                    }}
                                    form={form}
                                />
                            </div>
                            <div className="col form-col">
                                <CustomTextField
                                    id="OrganisationSDLNumber"
                                    label="SDL Number"
                                    className="w-100"
                                    onKeyPress={props.onKeyUp}
                                    InputProps={{
                                        readOnly: false,
                                    }}
                                    form={form}
                                />
                            </div>

                        </div>
                    </form>
                }
            </EntityForm >
        );
    }